module "inline" {
	var value = 123;
	export var a = "a";
	export function getValue() {
		return value;
	}
	export function setValue(v) {
		value = v;
	}
	export { value };
}

import { getValue as gv, setValue as sv, value as v } from "inline";

export function g() {
	return gv();
}

export function s(v) {
	sv(v);
}

export function gg() {
	return v;
}

export * from "inline";